import { TOTAL_STEPS } from "../constants";
import type { ViewState } from "../types";

export function Stepper({ view, stepIndex }: { view: ViewState; stepIndex: number }) {
  if (view === "error" || view === "idle") return null;
  return (
    <div className="ps-tryon-dots">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map(i => (
        <div key={i} className={`ps-tryon-dot${i < stepIndex ? " ps-done" : i === stepIndex ? " ps-active" : ""}`} />
      ))}
    </div>
  );
}
